<template>
  <div class="reviews-page-item">

    <div v-if="screenWidth >= 768" class="reviews-page-item-picture">
      <img
        :src="result.logo.src"
        :alt="result.logo.alt"
        :title="result.logo.title"
        class="reviews-page-item-picture__icon"
      >
    </div>
    <div class="reviews-page-item-content">
      <div class="reviews-header">
        <div class="reviews-member">
          <img
            :src="result.photo.src"
            :alt="result.photo.alt"
            :title="result.photo.title"
            alt="reviews-person"
            class="reviews-member__image"
          >
          <div>
            <p class="reviews-member__company">
              <b class="reviews-member__name">{{ result.name }}</b>
<!--              <span v-if="screenWidth >= 768">
                Компания Artemida
              </span>-->
            </p>
<!--            <p class="reviews-member__position">
              Волонтер компании Omega
            </p>-->
          </div>
        </div>
        <p v-if="screenWidth >= 768" class="reviews-date">
          {{ result.date }}
        </p>
      </div>


      <div class="reviews-text" v-html="result.text"></div>

    </div>
  </div>
</template>

<script>
export default {
  name: 'ReviewsPageItem',
  props: ['result'],
}
</script>

<style lang="scss" scoped>
.reviews-page-item {
  display: grid;
  grid-template-columns: 130px minmax(0, 803px);
  grid-column-gap: 108px;
  @include tablet{
    grid-column-gap: 29px;
  }
  @include mobile{
    grid-template-columns: 1fr;
  }
}
.reviews-page-item-picture{
  display: flex;
  align-items: center;
  justify-content: center;
  background: #FFFFFF;
  border: 1px solid #E9EBED;
  border-radius: 6px;
  height: 130px;
  &__icon{
    max-width: 65px;
  }
}
.reviews-page-item-content{
  background: #FFFFFF;
  border-radius: 6px;
  padding: 27px 27px 41px 31px;
  transition: .2s linear box-shadow;
  &:hover{
    box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.05), 0px 0px 40px rgba(0, 0, 0, 0.1);
  }
  @include tablet{
    padding: 27px 18px 29px 31px;
    box-shadow: none;
  }
  @include mobile{
    padding: 31px 10px 102px 25px;
  }

}
.reviews-member{
  display: grid;
  grid-template-columns: 50px 1fr;
  grid-column-gap: 12px;
  margin-bottom: 28px;
  @include mobile{
    grid-template-columns: 1fr;
    grid-row-gap: 11px;
    margin-bottom: 31px;
  }
  &__image{
    -o-object-fit: cover;
    object-fit: cover;
    width: 50px;
    height: 50px;
    border-radius: 50%;
  }
  &__company{
    font-size: 14px;
    line-height: 19px;
    color: #252425;
    margin-bottom: 2px;
    @include mobile{
      display: flex;
      flex-direction: column;
      margin-bottom: 3px;
    }
  }
  &__name{
    font-weight: 600;
    @include mobile{
      font-size: 18px;
      line-height: 28px;
    }
  }
  &__position{
    font-size: 14px;
    line-height: 20px;
    color: #6367A7;
    margin-bottom: 0;
  }
}
.reviews-header{
  display: flex;
  justify-content: space-between;
}
.reviews-date{
  font-size: 14px;
  line-height: 19px;
  color: #68737D;
  margin-bottom: 0;
}
.reviews-text{
  line-height: 24px;
  @include mobile{
    font-size: 14px;
    line-height: 20px;
  }
}
</style>